import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule, SVGIcon } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ActionSheetItem, BreadCrumbItem, NavigationModule } from '@progress/kendo-angular-navigation';
import { bellIcon, homeIcon, menuIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'casi-bread-crumb',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    ButtonsModule,
    IndicatorsModule,
    RouterModule,
    IconsModule,
    NavigationModule,
],
  templateUrl: './bread-crumb.component.html',
  styleUrl: './bread-crumb.component.scss'
})
export class BreadCrumbComponent {
  public hIcon: SVGIcon = homeIcon;
  public breadCrumbItems: BreadCrumbItem[] = [
    {
      text: "Home",
      title: "Home",
      svgIcon: this.hIcon,
    },
    {
      text: "Products",
      title: "Products",
    },
    {
      text: "Computer peripherals",
      title: "Computer peripherals",
    },
    {
      text: "Keyboards",
      title: "Keyboards",
    },
    {
      text: "Gaming keyboards",
      title: "Gaming keyboards",
    },
  ];
}
